module.exports = __webpack_public_path__ + "static/media/amilia.8e9424bc.svg";